import * as type from '../types';

export function setPortalData(data) {
  return {
    type: type.SET_PORTAL_DATA,
    payload: data,
  };
}
